/**
 * Most cloud-agent endpoints return `{ success: true, data: T }` or
 * `{ success: true, <key>: T }`. A few (system events, exchange) return
 * bare shapes. These helpers keep envelope handling out of the per-domain
 * clients.
 */

export interface SuccessEnvelope<T> {
  success: boolean;
  data?: T;
  message?: string;
  error_code?: string;
}

export function unwrapData<T>(payload: { success?: boolean; data?: T } | undefined | null): T {
  if (!payload || payload.data === undefined) {
    throw new Error('Response envelope missing `data` field.');
  }
  return payload.data;
}

export function unwrapKey<T>(payload: Record<string, unknown> | undefined | null, key: string): T {
  if (!payload || payload[key] === undefined) {
    throw new Error(`Response envelope missing \`${key}\` field.`);
  }
  return payload[key] as T;
}
